import React from "react";
import { Link } from "react-router-dom";
import { Mail, ExternalLink } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SERVICES } from "@/lib/api";

const POLICY_LINKS = [
  { to: "/cancellation-policy", label: "Cancellation Policy", testId: "footer-link-cancellation" },
  { to: "/payment-policy", label: "Payment Policy", testId: "footer-link-payment" },
  { to: "/privacy-policy", label: "Privacy Policy", testId: "footer-link-privacy" },
  { to: "/terms-of-service", label: "Terms of Service", testId: "footer-link-terms" },
];

export const SiteFooter = () => (
  <footer
    className="border-t"
    style={{ borderColor: "#E2E8F0", background: "#0B2545" }}
    data-testid="footer"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <Logo size="lg" inverted />
        <p
          className="mt-4 max-w-xs text-sm leading-relaxed"
          style={{ color: "rgba(255,255,255,0.78)" }}
        >
          Healthcare support services keeping clinical operations moving —
          safely, reliably, and on time.
        </p>
        <a
          href="https://tjclinicalsolutions.com"
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-5 inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-semibold tracking-wide transition-all hover:-translate-y-[1px]"
          style={{
            borderColor: "rgba(212,175,55,0.55)",
            background: "rgba(212,175,55,0.12)",
            color: "#E6C765",
          }}
          data-testid="footer-main-site-link"
        >
          Explore our full story
          <ExternalLink className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
        </a>
        <p
          className="mt-2 text-[11px] max-w-xs leading-relaxed"
          style={{ color: "rgba(255,255,255,0.55)" }}
        >
          Learn more about T&amp;J Clinical Solutions, our team, and the
          communities we serve at tjclinicalsolutions.com.
        </p>
      </div>
      <div>
        <div
          className="text-[11px] uppercase tracking-[0.22em] font-medium"
          style={{ color: "#E6C765" }}
        >
          Contact
        </div>
        <ul
          className="mt-3 space-y-2 text-sm"
          style={{ color: "rgba(255,255,255,0.85)" }}
        >
          <li className="flex items-center gap-2">
            <Mail className="h-4 w-4" style={{ color: "#D4AF37" }} />
            <a
              href="mailto:tj.clinicalsolutions@gmail.com"
              className="hover:underline"
              style={{ color: "rgba(255,255,255,0.85)" }}
            >
              tj.clinicalsolutions@gmail.com
            </a>
          </li>
        </ul>
      </div>
      <div>
        <div
          className="text-[11px] uppercase tracking-[0.22em] font-medium"
          style={{ color: "#E6C765" }}
        >
          Services
        </div>
        <ul
          className="mt-3 space-y-2 text-sm"
          style={{ color: "rgba(255,255,255,0.85)" }}
        >
          {SERVICES.slice(0, 5).map((s) => (
            <li key={s.id}>{s.label}</li>
          ))}
        </ul>
      </div>
      <div>
        <div
          className="text-[11px] uppercase tracking-[0.22em] font-medium"
          style={{ color: "#E6C765" }}
        >
          Policies
        </div>
        <ul
          className="mt-3 space-y-2 text-sm"
          style={{ color: "rgba(255,255,255,0.85)" }}
          data-testid="footer-policy-links"
        >
          {POLICY_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className="transition-colors hover:underline"
                style={{ color: "rgba(255,255,255,0.85)" }}
                data-testid={link.testId}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div
      className="border-t py-4 px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs"
      style={{
        borderColor: "rgba(255,255,255,0.08)",
        color: "rgba(255,255,255,0.6)",
      }}
    >
      <div>
        © {new Date().getFullYear()} T&amp;J Clinical Solutions. All rights
        reserved.
      </div>
      <Link
        to="/admin"
        className="uppercase tracking-[0.22em] font-medium transition-opacity hover:opacity-100"
        style={{ color: "rgba(255,255,255,0.45)" }}
        data-testid="footer-admin-link"
        aria-label="T&J Clinical Solutions internal portal"
      >
        T&amp;JCS
      </Link>
    </div>
  </footer>
);

export default SiteFooter;
